import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/lib/auth';
import { healthQuery } from '@/lib/query';

/**
 * Fixed yellow banner in the development environment (docs/08 §7, §11): `env` of `/auth/me` once
 * logged in, of `/health` on the login page.
 */
export function EnvBanner() {
  const { me } = useAuth();
  const { data } = useQuery({ ...healthQuery, enabled: !me });
  const env = me?.env ?? data?.env;
  if (env !== 'dev') return null;
  return (
    <div
      role="status"
      className="shrink-0 bg-env-banner px-4 py-0.5 text-center text-xs font-bold uppercase tracking-[0.2em] text-env-banner-foreground"
    >
      Ambiente di sviluppo
    </div>
  );
}
